/**
 * Click Toggle
 *
 * @module
 */

function toggleOn(toggler, target) {
    toggler.classList.add('toggled');
    toggler.setAttribute('aria-expanded', true);
    target.classList.add('toggled');
    target.setAttribute('aria-expanded', true);
}

function toggleOff(toggler, target) {
    toggler.classList.remove('toggled');
    toggler.setAttribute('aria-expanded', false);
    target.classList.remove('toggled');
    target.setAttribute('aria-expanded', false);
}

/**
 * Generic show/hide click toggle.
 *
 * Usage:
 * ```html
 * <button class="toggler" aria-controls="element-id"></button>
 * <div id="element-id">I am toggled by the button above.</div>
 * ```
 *
 * ```js
 * clickToggle('.toggler');
 * ```
 *
 * @param {Element} toggler
 * @return {void}
 */
export function clickToggle(toggler) {
    const target = document.getElementById(toggler.getAttribute('aria-controls'));

    if (!target) {
        console.error('Toggler element has an invalid target.', toggler);
        return;
    }

    (toggler.classList.contains('toggled') ? toggleOff : toggleOn)(toggler, target);
}
